export default __webpack_public_path__ + "478315b331b26695709e9725e066628c.webp";